export function Spinner({ fullPage = false, label = 'Loading…' }: { fullPage?: boolean; label?: string }) {
  return (
    <div className={fullPage ? 'spinner spinner--page' : 'spinner'} role="status" aria-live="polite">
      <span className="spinner__dot" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
